@import "@/ui/variables.css";

.dropdownMenuContent {
  border-radius: var(--radius);
  border: none;

  background: var(--gray);

  overflow: visible;

  position-area: bottom span-left;
  position: absolute;
  position-try: --span-bottom-right, --span-bottom-left, --span-top-right, --span-top-left;
  /* position-anchor: --popover-menu; This is set via react */
}

.dropdownMenuContent:popover-open {
  display: grid;
  gap: 0.5rem;
  padding: 0.5rem;
}

/* .dropdownMenuContent::backdrop { */
/*   background: oklch(0 0 0/0.2); */
/* } */

/* .dropdownMenuTrigger { */
/*   anchor-name: --popover-menu;  This is set via react */
/* } */

@position-try --span-bottom-right {
  inset: unset;
  position-area: bottom span-right;
}

@position-try --span-bottom-left {
  inset: unset;
  position-area: bottom span-left;
}

@position-try --span-top-left {
  inset: unset;
  position-area: top span-left;
}

@position-try --span-top-right {
  inset: unset;
  position-area: top span-right;
}
